import axios from 'axios';
import axiosRetry from 'axios-retry';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../messages';
import toastr from 'toastr';
const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getJobs = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_JOBS,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(iType === 1 ? `/api/app/Formal_Plaza/` : '/api/app/Funcional_Plaza/', {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    })
    dispatch({
      type: actions.GET_JOBS,
      payload: {
        jobs: resp.data.data,
        jobsLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_JOBS,
      payload: false
    });
  }
}

export const saveJob = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_JOBS,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(iType === 1 ? '/api/app/Formal_Plaza/' : '/api/app/Funcional_Plaza/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { jobs, jobsLength } = getState().jobs;
    const aJobs = [...jobs, resp.data];
    dispatch({
      type: actions.GET_JOBS,
      payload: {
        jobs: aJobs,
        jobsLength: jobsLength + 1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_JOBS,
      payload: false
    });
  }
}

export const editJob = (data, id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_JOBS,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(iType === 1 ? `/api/app/Formal_Plaza/${id}/` : `/api/app/Funcional_Plaza/${id}/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { jobs, jobsLength } = getState().jobs;
    jobs[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_JOBS,
      payload: {
        jobs: jobs,
        jobsLength: jobsLength
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_JOBS,
      payload: false
    });
  }
}

export const deleteJob = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_JOBS,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(iType === 1 ? `/api/app/Formal_Plaza/${id}/` : `/api/app/Funcional_Plaza/${id}/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { jobs, jobsLength } = getState().jobs;
    jobs.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_JOBS,
      payload: {
        jobs: jobs,
        jobsLength: jobsLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_JOBS,
      payload: false
    });
  }
}